import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NewsPage from './pages/NewsPage';
import ArticlePage from './pages/ArticlePage';
import StaticPage from './pages/StaticPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SponsorsPage from './pages/SponsorsPage';
import LetterRequestPage from './pages/LetterRequestPage';
import VolunteerPage from './pages/VolunteerPage';
import ResultsPage from './pages/ResultsPage';
import AdminPage from './pages/AdminPage';
import { Toaster } from './components/ui/sonner';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:slug" element={<ArticlePage />} />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/page/sponsors" element={<SponsorsPage />} />
            <Route path="/page/letter-requests" element={<LetterRequestPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/page/:slug" element={<StaticPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
